import React from "react"

import { useDispatchError } from "~/containers/Proposal/state/notifications/QueryErrorModal"
import { useProposalContext } from "~/containers/Proposal/state/proposal/proposal-context"
import { useFindPossibleTpoLoanProductTypesForProposalQuery } from "~/graphql/client"
import { useGraphqlClient } from "~/hooks/graphql"

import { GoodleapTpoUnavailableAlert } from "./GoodleapTpoUnavailableAlert"

export const GoodleapTpoOffers: React.FC = () => {
  const proposal = useProposalContext().remote
  const { client } = useGraphqlClient()
  const onError = useDispatchError()

  const possibleLoanProductTypesQuery =
    useFindPossibleTpoLoanProductTypesForProposalQuery(
      client,
      {
        proposalId: proposal.id,
      },
      {
        onError,
      },
    )

  const data =
    possibleLoanProductTypesQuery.data
      ?.findPossibleTpoLoanProductTypesForProposal

  if (data?.length === 0 || possibleLoanProductTypesQuery.isLoading) {
    return null
  }

  return <GoodleapTpoUnavailableAlert loanProductTypes={data ?? []} />
}
